export class InformacaoContrachequeDTO {

    constructor(
        public nome?: string,
        public matricula?: string,
        public local?: string,
        public mesAno?: string,
        public valorBruto?: string,
        public desconto?: string,
        public valorLiquido?: string,
        public banco?: string,
        public agencia?: string,
        public contaCorrent?: string,
        public depIR?: string,
        public depSalFam?: string,
        public margem30?: string,
        public margem70?: string,
        public cargo?: string,
        public salarioBase?: string,
        public valorFGTS?: string,
        public saldoAbono?: string,
        public msgTitle?: string,
        public nrBenefInss?: string,
        public nrNossoNumero?: string,
        public irIsencaoIr?: string,
        public cdFuncao?: string,
        public vPAN?: string
    ) {
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/dominios/DTO/informacoes-contracheque.DTO.ts